import USER_AVATAR from '../../assets/images/avatars/avatar.png'
import { useDispatch } from 'react-redux/';
import { useEffect, useState } from 'react';
import { fetchAllUsers } from '../../redux/slice/user/userSlice';
import Moment  from 'react-moment';

const StatusCard = ({data}) => {
    const dispatch = useDispatch()
    // const { all_users, isSuccess } = useSelector(state => state.user)
    const all_users = []
    // const isSuccess = true
    const [sorting, setSorting] = useState(false)

    useEffect(() => {
        dispatch(fetchAllUsers())
    },[dispatch])

    // useEffect(() => {
    //     if (isSuccess) {
    //       dispatch(resetUsers())
    //       return;
    //     }
    
    //   }, [dispatch, isSuccess]);

    // useEffect(() => {
    //     if(all_users.length > 0){
    //         setCurrentUsers(all_users)
    //     }
    // },[all_users])

    // useEffect(()=>{
    //     setTimeout(() => {
    //         setSorting(false)
    //     }, 500);
    //     clearTimeout()
    // },[currentUsers])
  return (
    <div className="col-xl-4 col-lg-6 order-lg-1">
    <div className="card scrollbar-hide" style={{ height: '350px' }}>
        <div className="card-body pb-0">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="header-title mb-0">Online Users({data?.length})</h4>
                {/* <div>
                    <select className="form-select form-select-sm" aria-label=".form-select-sm example"
                    onChange={(e) => filterUsers(e.target.value)}
                    >
                        <option value='1'>Active ({all_users
                        && all_users?.data?.filter(f => f.loggedin === 1).length
                        })</option>
                        <option value="0">Offline ({all_users
                        && all_users?.data?.filter(f => f.loggedin === 0).length
                        })</option>
                    </select>
                </div> */}
            </div>
        </div>

        <div className="card-body py-0" data-simplebar="init" style={{maxHeight: '292px'}}>
            <div className="simplebar-wrapper"  style={{margin: '0px -24px'}}>
                <div className="simplebar-height-auto-observer-wrapper">
                    <div className="simplebar-height-auto-observer"></div>
                </div>
                <div className="simplebar-mask">
                    <div className="simplebar-offset"  style={{right: '0px', bottom: '0px'}} >
                        <div className="simplebar-content-wrapper" tabIndex="0" role="region" aria-label="scrollable content" style={{height: 'auto', overflow: 'hidden scroll'}}>
                    <div className="simplebar-content" style={{padding: '0px 24px'}}>
            {
                data?.length === 0 || !data ?
                <h4>Loading...</h4>
                :
                data && 
                data?.length > 0 ?
                data?.map(({id, first_name, last_name, last_seen, loggedin}, index) => (
                    index <= 9 &&
                    <div key={id} className="d-flex align-items-center border-bottom pb-2 pt-2 mb-2">
                        <div className="avatar position-relative">
                                <img className="me-3 rounded-circle" src={USER_AVATAR} width="40" alt="Generic placeholder"/>
                            <span className={`status-indicator bg-success rounded-circle`} style={{ width: "10px", height: "10px" }}></span>
                        </div>
                        <div className="w-100 overflow-hidden">
                            <h5 className="mt-0 mb-0 fw-semibold">{first_name} {last_name}</h5>
                            <ul className="list-inline mb-0 font-13">
                               <li className="list-inline-item text-muted">
                                   online
                                </li>                        
                            </ul>
                        </div>
                    </div>
                ))
                :
                <div className='alert alert-info'>No Record Found</div>
            }
            

            </div></div></div></div><div className="simplebar-placeholder" style={{width: 'auto', height: '396px'}}>
            </div></div><div className="simplebar-track simplebar-horizontal" style={{visibility: 'hidden'}}><div className="simplebar-scrollbar" style={{width: '0px', display: 'none'}}>
            </div></div><div className="simplebar-track simplebar-vertical" style={{visibility: 'visible'}}><div className="simplebar-scrollbar" style={{height: '215px', transform: 'translate3d(0px, 77px, 0px)', display: 'block'}}></div></div></div>
        </div>
    </div>
  )
}

export default StatusCard